import React, { useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Zap } from 'lucide-react';

const legalTexts = {
  "mesafeli-satis": {
    title: "Mesafeli Satış Sözleşmesi",
    content: `1. TARAFLAR
İşbu Sözleşme aşağıdaki taraflar arasında aşağıda belirtilen hüküm ve şartlar çerçevesinde imzalanmıştır.
A. 'ALICI' (Sözleşmede bundan sonra "ALICI" olarak anılacaktır)
B. 'SATICI' (Sözleşmede bundan sonra "SATICI" olarak anılacaktır)
Unvanı: Cularix Yazılım Tic. Ltd. Şti.

2. KONU
İşbu sözleşmenin konusu, ALICI'nın SATICI'ya ait Cularix POS internet sitesinden elektronik ortamda siparişini yaptığı aşağıda nitelikleri ve satış fiyatı belirtilen hizmetin satışı ve ifası ile ilgili olarak 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmelere Dair Yönetmelik hükümleri gereğince tarafların hak ve yükümlülüklerinin saptanmasıdır.

3. SÖZLEŞME KONUSU HİZMET BİLGİLERİ
Malın / Ürün / Hizmetin türü, miktarı, marka/modeli, rengi, adedi, satış bedeli, ödeme şekli, siparişin sonlandığı andaki bilgilerden oluşmaktadır.

4. GENEL HÜKÜMLER
4.1. ALICI, SATICI'ya ait internet sitesinde sözleşme konusu ürünün temel nitelikleri, satış fiyatı ve ödeme şekli ile teslimata ilişkin ön bilgileri okuyup bilgi sahibi olduğunu ve elektronik ortamda gerekli teyidi verdiğini beyan eder.
4.2. Sözleşme konusu hizmet, yasal 30 günlük süreyi aşmamak koşulu ile her bir ürün için ALICI'nın yerleşim yerinin uzaklığına bağlı olarak internet sitesinde ön bilgiler kısmında açıklanan süre zarfında ALICI veya gösterdiği adresteki kişi/kuruluşa teslim edilir/aktif edilir.`
  },
  "iptal-iade": {
    title: "İptal ve İade Koşulları",
    content: `1. İADE HAKKI
Kullanıcı, satın almış olduğu yazılım lisans/abonelik hizmetini, hizmetin aktif edildiği tarihten itibaren 14 (on dört) gün içerisinde hiçbir gerekçe göstermeksizin ve cezai şart ödemeksizin iptal etme hakkına sahiptir.

2. İADE ŞARTLARI
Elektronik ortamda anında ifa edilen hizmetler veya tüketiciye anında teslim edilen gayrimaddi mallar, Mesafeli Sözleşmeler Yönetmeliği uyarınca cayma hakkının istisnaları kapsamındadır. Ancak müşteri memnuniyeti adına firmamız ilk 14 gün içinde yapılan iade taleplerini değerlendirmekte ve olumlu sonuçlandırabilmektedir.

3. İADE SÜRECİ
İade talepleri info@cularix.com adresine yazılı olarak bildirilmelidir. İadenin onaylanmasının ardından, ödeme kredi kartı ile yapılmışsa ücret iadesi bankanın süreçlerine bağlı olarak 1-3 iş günü içerisinde karta yansıtılır.`
  },
  "gizlilik": {
    title: "Gizlilik ve Güvenlik Politikası",
    content: `1. KİŞİSEL VERİLERİN KORUNMASI
Cularix Yazılım ("Firma"), kullanıcıların www.cularix.com ("Web Sitesi") üzerinden ilettikleri kişisel bilgilerini, Gizlilik Politikası ile belirlenen amaçlar ve kapsam dışında kullanmayacak, ayrıca izinsiz olarak üçüncü kişilerle paylaşmayacaktır.

2. BİLGİ GÜVENLİĞİ
Kişisel bilgileriniz, yetkisiz erişimi, kaybolmasını veya kötüye kullanımını önlemek amacıyla uygun teknik ve fiziksel güvenlik önlemleri ile korunmaktadır. Ödeme sayfalarımızda 256-bit SSL sertifikası kullanılmakta olup kredi kartı bilgileriniz hiçbir şekilde sunucularımızda saklanmamaktadır (Ödemeler Iyzico altyapısı ile güvence altına alınmıştır).

3. ÇEREZLER (COOKIES)
Web Sitemiz, kullanıcı deneyimini iyileştirmek amacıyla çerezler (cookies) kullanabilmektedir.`
  },
  "kvkk": {
    title: "KVKK Aydınlatma Metni",
    content: `6698 SAYILI KİŞİSEL VERİLERİN KORUNMASI KANUNU ("KVKK") KAPSAMINDA AYDINLATMA METNİ

1. Veri Sorumlusunun Kimliği
Cularix Yazılım Tic. Ltd. Şti. olarak kişisel verilerinizin güvenliği hususuna azami hassasiyet göstermekteyiz.

2. Kişisel Verilerin İşlenme Amacı
Toplanan kişisel verileriniz, şirketimiz tarafından sunulan ürün ve hizmetlerden sizleri faydalandırmak için gerekli çalışmaların iş birimlerimiz tarafından yapılması, hesaplarınızın oluşturulması ve ödeme işlemlerinin gerçekleştirilmesi amaçlarıyla işlenmektedir.

3. Kişisel Verilerin Aktarılması
Kişisel verileriniz, yasal düzenlemelerin öngördüğü kapsamda, yasal yükümlülüklerimizin yerine getirilmesi amacıyla yetkili kamu kurum ve kuruluşlarına, ödeme altyapısı sağlayıcılarına (örn. Iyzico) aktarılabilmektedir.`
  }
};

const LegalPage = () => {
  const { docId } = useParams();
  const doc = legalTexts[docId] || { title: "Sayfa Bulunamadı", content: "Aradığınız belgeye ulaşılamadı." };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [docId]);

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#07070B', color: '#fff' }}>
      {/* Ambient */}
      <div className="fixed inset-0 pointer-events-none" style={{
        background: 'radial-gradient(ellipse 70% 40% at 50% -10%, rgba(249,115,22,0.10) 0%, transparent 70%)'
      }} />

      {/* Header */}
      <header className="relative z-10 border-b px-6 py-4 flex items-center justify-between"
        style={{ borderColor: 'rgba(255,255,255,0.07)', backgroundColor: 'rgba(7,7,11,0.8)', backdropFilter: 'blur(16px)' }}>
        <Link to="/" className="flex items-center gap-2 text-sm font-medium transition-colors"
          style={{ color: 'rgba(255,255,255,0.5)' }}
          onMouseEnter={e => e.currentTarget.style.color = 'rgba(255,255,255,0.9)'}
          onMouseLeave={e => e.currentTarget.style.color = 'rgba(255,255,255,0.5)'}>
          <ArrowLeft size={16} />
          Ana Sayfaya Dön
        </Link>
        <div className="flex items-center gap-2">
          <img src="/logo.png" alt="Cularix" className="w-6 h-6 object-contain" />
          <span className="font-bold text-white">Cularix</span>
        </div>
      </header>

      {/* Content */}
      <main className="relative z-10 flex-1 max-w-3xl w-full mx-auto px-4 py-12">
        <div className="rounded-3xl p-8 sm:p-10"
          style={{
            backgroundColor: 'rgba(255,255,255,0.03)',
            border: '1px solid rgba(255,255,255,0.08)',
            backdropFilter: 'blur(12px)',
          }}>
          {/* Title */}
          <div className="mb-8 pb-6" style={{ borderBottom: '1px solid rgba(255,255,255,0.07)' }}>
            <div className="flex items-center gap-2 mb-3">
              <div className="w-1 h-6 rounded-full bg-orange-500" />
              <span className="text-xs font-semibold uppercase tracking-widest" style={{ color: '#f97316' }}>
                Hukuki Belge
              </span>
            </div>
            <h1 className="text-3xl font-bold text-white">{doc.title}</h1>
          </div>

          {/* Body */}
          <div className="text-sm leading-relaxed whitespace-pre-line"
            style={{ color: 'rgba(255,255,255,0.55)', lineHeight: '1.9' }}>
            {doc.content}
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 py-6 text-center text-xs"
        style={{ color: 'rgba(255,255,255,0.2)', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
        © {new Date().getFullYear()} Cularix Yazılım Tic. Ltd. Şti. Tüm Hakları Saklıdır.
      </footer>
    </div>
  );
};

export default LegalPage;
